import React, {PropTypes} from 'react';
import {connect} from 'react-redux';

import scrollToComponent from 'react-scroll-to-component';

import {PRIMARY_CUSTOMER_SERVICE} from '../../../../constants/contacts';

// import * as headerActionCreators from '../../../actions/header';
let allActionCreators = Object.assign({});

class Holiday2019 extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
	}

	internalNav(page) {
    this.context.router.push('/' + page);
  }

	externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  scrollToDates() {
    scrollToComponent(this.biosSection, {
      offset: 0, 
      align: 'middle', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

	render() {
		return <div className='Holiday2019'>
			<div className="promoBanner">
				<img className='desktop600' src="https://s3.amazonaws.com/dd-website/img/promopages/holiday2019/landingbanner_a.jpg" alt="Diamonds Direct Summer" />
				<img className='mobile600' src="https://s3.amazonaws.com/dd-website/img/promopages/holiday2019/landingbanner_mobile_a.jpg" alt="Diamonds Direct Summer" />				
			</div>
			<div className='preBoxText'>
				<div className='holidayTextLarge'>Only Diamonds Direct has multiple offers for you to sparkle and save this holiday season!</div>
				<div className='notabutton'>SHOP IN STORE</div>
				<div className='holidayText'>You’re invited to our Holiday Designer Showcase!</div>
				<div className='holidayTextAgain'>Five stores left for the sale of the season! <strong>Dec. 6 - 8</strong>.</div>
				<div className='holidayPercent'>20% Savings</div>
				<div className='holidayTextOnceMore'>on engagement ring settings, wedding bands AND fine fashion jewelry like diamond studs, pendants, bracelets and more!</div>
				<div className='holidayTextForTheFifthTimeInADifferentStyleWhyGodWhy'>Visit a Showroom Near You:</div>
			</div>
			<div className="promoBody" ref={(div) => { this.biosSection = div; }}>
				<div className="promoBodyInner">
					<div className="springLocationBlock">
						<div className={"springLocationItem"}>
							<div className={"springDates pastDate"}>
								<div className='desktopOnly'>Nov. 15-17&nbsp;&nbsp;&nbsp;</div>
								<div className='mobileOnly'>Nov. 15-17</div>
							</div>
							<div className={"springLocations pastDate"}>
								<a className="holiday-location-link" href="/charleston">Charleston,&nbsp;SC</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/oklahoma-city">Oklahoma&nbsp;City,&nbsp;OK</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/richmond">Richmond,&nbsp;VA</a>
								<br />
								<a className="holiday-location-link" href="/indianapolis">Indianapolis,&nbsp;IN</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/jacksonville">Jacksonville,&nbsp;FL</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/columbus">Columbus,&nbsp;OH</a>
								<br />
								<a className="holiday-location-link" href="/kansas-city">Kansas&nbsp;City,&nbsp;KS</a>
							</div>
						</div>
						<div className="springLocationItem">
							<div className={"springDates pastDate"}>
								<div className='desktopOnly'>Nov. 22-24&nbsp;&nbsp;&nbsp;</div>
								<div className='mobileOnly'>Nov. 22-24</div>
							</div>
							<div className={"springLocations pastDate"}>
								<a className="holiday-location-link" href="/charlotte">Charlotte,&nbsp;NC</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/birmingham">Birmingham,&nbsp;AL</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/raleigh">Raleigh,&nbsp;NC</a>
								<br />
								<a className="holiday-location-link" href="/virginia-beach">Virginia&nbsp;Beach,&nbsp;VA</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/frisco">Frisco,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/dallas">Dallas,&nbsp;TX</a>
								<br />
								<a className="holiday-location-link" href="/cleveland">Cleveland,&nbsp;OH</a>
							</div>
						</div>
						<div className={"springLocationItem doubleLine"}>
							<div className="springDates">
								<div className='desktopOnly'>Dec. 6-8&nbsp;&nbsp;&nbsp;</div>
								<div className='mobileOnly'>Dec. 6-8</div>
							</div>
							<div className={"springLocations"}>
								<a className="holiday-location-link" href="/austin">Austin,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/san-antonio">San&nbsp;Antonio,&nbsp;TX</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/st-louis">St.&nbsp;Louis,&nbsp;MO</a>
								<br />
								<a className="holiday-location-link" href="/salt-lake-city">Salt&nbsp;Lake&nbsp;City,&nbsp;UT</a>
								&nbsp;<span className='link-em'>|</span>&nbsp;
								<a className="holiday-location-link" href="/new-orleans">New&nbsp;Orleans,&nbsp;LA</a>
							</div>
						</div>
					</div>
				</div>
				<div className='footerButton'>
					<div className='onlineButton' onClick={() => this.externalNav('catalogsearch/advanced/?a=1&prod_type=engagement&attr=&opt=&dsgnr_id=&prc_min=1&prc_max=20000&order_by=rnd&limit=12&pg_no=1&url_prod_type=&q=')}><div>Shop Online</div></div>
				</div>
				<div className='footerText1'>Enjoy 20% savings</div>
				<div className='footerText2'>On select engagement ring settings.</div>
				<div className='footerText3'>November 15<sup>th</sup> – December 8<sup>th</sup></div>
				<div className='footerText4'>Discount applied in cart</div>
				<div className='promoLegal'>
					*Discount excludes certified diamonds and price-protected lines.<br />Cannot be combined with other offers.
				</div>
			</div>
		</div>;
	}
}
export default Holiday2019;

function mapStateToProps(state) {
  return {

  };
}

export const Holiday2019Container = connect(
  mapStateToProps,
  allActionCreators
)(Holiday2019);


// WEBPACK FOOTER //
// ./src/components/views/promopages/holiday2019/Holiday2019.jsx